<template>
  <div>
    <div class="row">
      <div class="col-6 grid-padding-10">
        <label>Wybierz kuwerturę którą chcesz wlać:</label>
        <v-select
          label="name"
          :options="couverturesOnShelf"
          v-model="couverture"
          @search="getCouverture"
        ></v-select>
        <div class="alert alert-danger" v-if="this.couvertureError">
          {{ this.couvertureError }}
        </div>
      </div>
      <div class="col-4">
        <label>Waga:</label>
        <input
          type="number"
          step="0.001"
          class="form-control"
          v-model="weight"
        />
        <div class="alert alert-danger" v-if="this.weightError">
          {{ this.weightError }}
        </div>
      </div>
      <div class="col-1 buttons-col-area">
        <button
          type="button"
          class="btn btn-primary button-col"
          @click="RemoveItem"
        >
          Usuń
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CouvertureService from "../../services/couverture.service";

export default {
  props: ["item"],
  watch: {
    weight(value) {
      this.weightError = undefined;
      this.item.isValid = true;

      if (this.item.couverture && this.item.couverture.totalWeight) {
        this.item.weight = value;
        if (value > this.item.couverture.totalWeight) {
          this.weightError = "Wpisana waga przekracza dostępną wagę kuwertury";
          this.item.isValid = false;
        }
      } else {
        this.couvertureError = "Należy wybrać kuwerturę";
        this.item.isValid = false;
      }
    },
    couverture(value) {
      this.couvertureError = undefined;
      this.item.isValid = true;

      this.item.couverture = value;
      if (this.item.couverture.weight == undefined) {
        this.item.weight = 0;
        this.weight = 0;
      }
    },
  },
  data() {
    return {
      weight: undefined,
      weightError: undefined,
      couverture: undefined,
      couvertureError: undefined,
      couverturesOnShelf: [],
    };
  },
  methods: {
    getCouverture(name) {
      if (name.length > 2) {
        var that = this;
        CouvertureService.getCouverturesOnShelf(name).then((res) => {
          that.couverturesOnShelf = res.data;
        });
      }
    },
    RemoveItem() {
      this.$emit("mixCouvertureItemDelete", this.item.id);
    },
  },
};
</script>